import React, { useEffect, useState } from 'react';
import styles from './SettingsNavbar.module.css';
import Loader from '../../Loader/Loader';
import { toast } from 'react-toastify';

const SettingsNavbar = ({
  setType,
  allTypes,
  setIsRelated,
  isTypesLoading,
}) => {
  const [activeLink, setActiveLink] = useState(1);

  const handelOnCLick = (item) => {
    setType(item.ddtypeId);
    setActiveLink(item.ddtypeId);

    if (item.relatedTo !== null) {
      setIsRelated(item.relatedTo);
    } else {
      setIsRelated(null);
    }

    if (item.ddtypeId === 9 || item.ddtypeId === 10) {
      toast.warning('Select a country to reveal the data');
    }
  };

  if (isTypesLoading) {
    return <Loader />;
  }
  return (
    <div className={styles['navbar-container']}>
      <div className={styles['attributes']}>الخصائص</div>

      <ul className={styles['ul-cont']}>
        {allTypes?.data?.map((item, index) => (
          <li
            key={item.ddtypeId}
            className={`${
              item.ddtypeId === activeLink ? styles.activeListItem : ''
            }
                ${index % 2 === 0 ? styles.listItem2 : styles.listItem} `}
            onClick={() => handelOnCLick(item)}
          >
            {item.type}
          </li>
        ))}

        {/* <li
          className={
            activeLink === 16
              ? `${styles.activeListItem} ${styles.listItem2}`
              : styles.listItem2
          }
          onClick={() => handelOnCLick({ ddtypeId: 16, relatedTo: null })}
        >
          Terms
        </li> */}
      </ul>
    </div>
  );
};

export default SettingsNavbar;
